const TOUCHPOINT_NEXT_ARROW_SVG =
    '<svg preserveAspectRatio="none" width="100%" height="100%" overflow="visible" style="display: block;" viewBox="0 0 12.9792 12.6359" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">' +
    '<path d="M10.1458 7.15672H0.833333C0.597222 7.15672 0.399306 7.07685 0.239583 6.91713C0.0798611 6.75741 0 6.55949 0 6.32338C0 6.08727 0.0798611 5.88935 0.239583 5.72963C0.399306 5.56991 0.597222 5.49005 0.833333 5.49005H10.1458L6.0625 1.40672C5.89583 1.24005 5.81597 1.0456 5.82292 0.823382C5.82986 0.60116 5.91667 0.406715 6.08333 0.240049C6.25 0.0872709 6.44444 0.00740975 6.66667 0.000465304C6.88889 -0.00647914 7.08333 0.073382 7.25 0.240049L12.75 5.74005C12.8333 5.82338 12.8924 5.91366 12.9271 6.01088C12.9618 6.1081 12.9792 6.21227 12.9792 6.32338C12.9792 6.43449 12.9618 6.53866 12.9271 6.63588C12.8924 6.7331 12.8333 6.82338 12.75 6.90672L7.25 12.4067C7.09722 12.5595 6.90625 12.6359 6.67708 12.6359C6.44792 12.6359 6.25 12.5595 6.08333 12.4067C5.91667 12.24 5.83333 12.0421 5.83333 11.813C5.83333 11.5838 5.91667 11.3859 6.08333 11.2192L10.1458 7.15672Z" fill="currentColor"></path>' +
    "</svg>";

class UXManager {
    constructor() {
        this.addListeners();
    }

    isEditing() {
        return !!$("#ccm-menu-click-proxy").length;
    }

    addListeners() {
        $(window).on("scroll resize", this.onScroll);
        $(window).trigger("scroll");
        $(document).ready(this.onReady.bind(this));

        $(".tile.banner.position_.event")
                .each(function (index) {
                    $(this).attr("data-id", index);
                })
                .on("click", function () {
                    let container = $(".zoomedimage");
                    let imageSrc = $(this).find(".image").attr("data-bg");
                    if ($(".zoomedimage").length == 0) {
                        $("body")
                                .append(
                                        '<div class="zoomedimage tile banner position_ event"></div>'
                                        )
                                .css("overflowY", "hidden");
                        container = $(".zoomedimage");
                    }
                    container
                            .css("backgroundImage", "url(" + imageSrc + ")")
                            .attr("data-rel", $(this).attr("data-id"))
                            .hide()
                            .fadeIn(500);
                });

        $(document).on("click", ".zoomedimage", function () {
            $("body").css("overflowY", "scroll");
            $(this).fadeOut(500);
        });
    }

    onScroll() {
        const animation_elements = $(".animation-element");

        const window_height = $(window).height();
        const window_top_position = $(window).scrollTop();
        const window_bottom_position = window_top_position + window_height;

        if (window_top_position == 0) {
            $("body").removeClass("scrolled");
        } else {
            $("body").addClass("scrolled");
        }

        $.each(animation_elements, function () {
            const element_height = $(this).outerHeight();
            const element_top_position = $(this).offset().top;
            const element_bottom_position = element_top_position + element_height;

            if (
                    element_bottom_position >= window_top_position &&
                    element_top_position <= window_bottom_position
                    ) {
                $(this).addClass("in-view");
            } else {
                $(this).removeClass("in-view");
            }
        });

    }

    onReady() {
//    this.convertImgToSvg();
        this.captureUtmParams();
        this.activateTabsets();
        this.animateKeyNumbers();
        this.activateCustomSelect();
        this.activateCalendarTrigger();
        this.activateDrawer();
        this.activateLazyContentLists();
        this.activateZoomables();
        this.activateLoadMore();
        this.activateDestinationLinks();
        this.activateHamburger();
        this.fixHPUX();
        this.fixClubUX();
        this.fixAggregatorUX();
        this.fixCartoucheUX();
        this.activateContactTabs();
        this.monitorTouchpontSubmit();
        this.activateFormSteps();
        this.activateSmartAccordion();
        this.openFirstItemInSmartAccordions();
        this.magicAccordion();
        this.cleanParagraphEmpty();

        if (typeof window.__cfBindSectionStepsSlider === "function") {
            window.__cfBindSectionStepsSlider();
        }

        if (typeof window.__cfBindTestimonialsSlider === "function") {
            window.__cfBindTestimonialsSlider();
        }

        const form = document.querySelector("form.touchpoint"); // seleziona il form
        const buttons = document.querySelectorAll('a[href="#scrollToForm"]'); // seleziona tutti i bottoni/link

        buttons.forEach((button) => {
            button.addEventListener("click", function (e) {
                e.preventDefault();
                form.scrollIntoView({behavior: "smooth"});
            });
        });
    }
    
    captureUtmParams() {
        const UTM_KEYS = [
            "utm_source",
            "utm_medium",
            "utm_campaign",
            "utm_term",
            "utm_content",
            "gclid",
            "fbclid",
        ];
        const STORAGE_PREFIX = "utm_"; // es. sessionStorage "utm_utm_source"
        const params = new URLSearchParams(window.location.search);
        let foundInUrl = false;

        UTM_KEYS.forEach((key) => {
            const value = params.get(key);
            if (value === null || String(value).trim() === "") {
                return;
            }
            foundInUrl = true;
            sessionStorage.setItem(STORAGE_PREFIX + key, value.trim());
        });

        if (foundInUrl) {
            sessionStorage.setItem(STORAGE_PREFIX + "captured_at", String(Date.now()));
            sessionStorage.setItem(STORAGE_PREFIX + "landing_page", window.location.href);
        }
    }

    getStoredUtm(key) {
        return sessionStorage.getItem("utm_" + key) || "";
    }

    convertImgToSvg() {
        $("img.svg").each(function () {
            const img = $(this);
            const imgID = img.attr("id");
            const imgClass = img.attr("class");
            const imgURL = img.attr("src");
            const altText = img.attr("alt");
            $.get(
                    imgURL,
                    function (data) {
                        let svg = $(data).find("svg");
                        if (typeof imgID !== "undefined") {
                            svg = svg.attr("id", imgID);
                            svg = svg.attr("alt", altText);
                        }
                        if (typeof imgClass !== "undefined") {
                            svg = svg.attr("class", imgClass + " replaced-svg");
                        }
                        svg = svg.removeAttr("xmlns:a");
                        if (!svg.attr("viewBox") && svg.attr("height") && svg.attr("width")) {
                            svg.attr(
                                    "viewBox",
                                    "0 0 " + svg.attr("height") + " " + svg.attr("width")
                                    );
                        }
                        img.replaceWith(svg);
                    },
                    "xml"
                    );
        });
    }

    activateTabsets() {
        let foundts = [];
        $("[data-tabset]").each(function () {
            const tsn = $(this).attr("data-tabset");
            const trn = $(this).attr("data-tabrel");
            const tab = $('[data-tab="' + trn + '"]');

            $(tab).on("click", function (e) {
                ux.clickTabsetTab(this);
            });

            if (!foundts.includes(tsn)) {
                foundts.push(tsn);
                $(this).show();

                tab.addClass("active");
            } else {
                if (!ux.isEditing()) {
                    $(this).hide();
                }
                tab.removeClass("active");
            }
        });
    }

    clickTabsetTab(el) {
        const trn = $(el).attr("data-tab");
        const tabc = $('[data-tabrel="' + trn + '"]');
        const tsn = tabc.attr("data-tabset");

        $('[data-tabset="' + tsn + '"]').each(function () {
            const trn = $(this).attr("data-tabrel");
            const tab = $('[data-tab="' + trn + '"]');

            tab.removeClass("active");
            $(this).hide();
        });

        $(el).addClass("active");
        tabc.show();
    }

    animateKeyNumbers() {
        $(".key-number").each(function () {
            var $this = $(this);

            const countTo = $(this).children("span").text();

            if ($this.hasClass(".key-number-animated")) {
                $({countNum: 1}).animate(
                        {
                            countNum: countTo,
                        },
                        {
                            duration: 2000,
                            easing: "swing",
                            step: function () {
                                const l = $("html").attr("lang");
                                const s = $this.children("span");
                                let t = Math.floor(this.countNum).toLocaleString(l);
                                if (s.attr("data-append"))
                                    t += s.attr("data-append");
                                s.text(t);
                            },
                            complete: function () {
                                const l = $("html").attr("lang");
                                const s = $this.children("span");
                                let t = this.countNum.toLocaleString(l);
                                if (s.attr("data-append"))
                                    t += s.attr("data-append");
                                s.text(t);
                            },
                        }
                );
            } else {
                const l = $("html").attr("lang");
                const s = $this.children("span");
                let t = Math.floor(countTo).toLocaleString(l);
                if (s.attr("data-append"))
                    t += s.attr("data-append");
                s.text(t);
            }
        });
    }

    activateCustomSelect() {
        $(document).on(
                "click focus",
                ".component.form-element.select:not(.status-disabled)",
                function (e) {
                    if ($(e.target).hasClass("search-element"))
                        return;
                    if ($(e.target).parent().hasClass("search-element"))
                        return;

                    if (e.type == "click") {
                        const op = $(this).children(".optionpositioner");
                        if (op.is(":visible")) {
                            //console.log('|||||||||||||||||||| click focus');
                            //console.log('procedo a chiudere', op);

                            op.hide();
                        } else {
                            //console.log('|||||||||||||||||||| click focus');
                            //console.log('procedo a aprire', op);

                            op.show();
                            op.find('[type="search"]').focus();
                        }
                    }
                }
        );

        $(document).on(
                "click",
                ".component.form-element.select .options li",
                function (el) {
                    if ($(this).hasClass("search-unclickable-element"))
                        return;

                    $(this).siblings().removeClass("selected");
                    $(this).addClass("selected");

                    const op = $(this).closest(".component.form-element");
                    op.children('input[type="text"]').val($(this).text());
                    op.children('input[type="hidden"]').val($(this).attr("data-value"));
                }
        );

        $(document).on("click", function (e) {
            if ($(e.target).hasClass("search-element"))
                return;
            if ($(e.target).parent().hasClass("search-element"))
                return;

            const cfe = $(e.target).closest(".component.form-element");
            const op = cfe.find($(".optionpositioner"));

            $(".optionpositioner").each(function () {
                if (!$(this).is(op) && $(this).is(":visible")) {
                    //console.log('|||||||||||||||||||| document click');
                    //console.log('procedo a chiudere', this);

                    $(this).hide();
                }
            });
        });
    }

    activateLazyContentLists() {
        $('.async_content_list:not(".deferred")').each(function () {
            //console.log('00 |||||||||||||||||||| activateLazyContentLists', this);
            window.ux.activateLazyContentList(this);
        });
    }

    activateLazyContentList(el, insertiontarget, insertionmode, contentlevel) {
        //console.log((new Error()).stack);
        //console.log('01 |||||||||||||||||||| activateLazyContentList', $(el));

        //return false;
        const bid = $(el).attr("data-bid");
        let filters = {};
        try {
            filters[bid] = JSON.parse($(el).attr("data-filters"));
        } catch (e) {
            console.error(
                    "Errore nel parsing del json filters",
                    $(el).attr("data-filters")
                    );
            console.log(el);
            return false;
        }

        filters = this.scanForParentselector(filters, bid);
        const id = $(el).attr("data-id");
        const segment = $(el).attr("data-segment");
        const template = $(el).attr("data-template");
        let settings = {};

        try {
            settings = JSON.parse($(el).attr("data-settings"));
        } catch (e) {
            console.error(
                    "Errore nel parsing del json settings",
                    $(el).attr("data-settings")
                    );
            console.log(el);
            return false;
        }

        if (id == "------")
            return false;
        if (!insertiontarget)
            insertiontarget = el;
        if (!insertionmode)
            insertionmode = "replace";

        this.getLazyContentList(
                el,
                bid,
                filters,
                id,
                segment,
                template,
                settings,
                insertiontarget,
                insertionmode,
                contentlevel
                );
    }

    scanForParentselector(filters, bid) {
        if (filters[bid].hasOwnProperty("parentselector")) {
            const parentid = $(filters[bid].parentselector).attr("data-parentid");
            if (typeof parentid !== "undefined") {
                filters[bid].parentid = parentid;
            }
        }

        return filters;
    }

    getLazyContentList(
            el,
            bid,
            filters,
            id,
            segment,
            template,
            settings,
            insertiontarget,
            insertionmode,
            contentlevel
            ) {
        //return false;

        //console.log('02 |||||||||||||||||||| getLazyContentList', $(el));

        const data = {
            filters: filters,
            id: id,
            bid: bid,
            segment: segment,
            template: template,
            settings: settings,
        };

        const options = {
            type: "POST",
            dataType: "html",
            url: "/content/list",
            context: el,
            data: JSON.stringify(data),
            success: function (j) {
                //console.log('03 |||||||||||||||||||| getLazyContentList RESPONSE', $(el));
                if ($(el).hasClass("async_content_list")) {
                    window.ux.renderContentList(
                            el,
                            j,
                            bid,
                            filters,
                            settings,
                            insertiontarget,
                            insertionmode,
                            contentlevel
                            );
                    window.ux.fixAggregatorUX();
                } else if ($(el).hasClass("drawer")) {
                    window.ux.renderDrawer(el, j, bid, filters, settings);
                }
            },
            error: function (j) {},
        };
        $.ajax(options);
    }

    skeletonContentList(el) {
        $(el).find(".tile:not(.skeleton)").addClass("skeleton");
    }

    renderContentList(
            el,
            j,
            bid,
            filters,
            settings,
            insertiontarget,
            insertionmode,
            contentlevel
            ) {
        if (contentlevel == "children") {
            let cj = $.parseHTML(j);
            j = $(cj).children();
        }

        this.insertInDom(insertiontarget, j, insertionmode);

        this.renderCount(el);
        let cardsnum = $(el).find("[data-card]");

        if (
                cardsnum.length == 0 &&
                settings.emptystate == "hide" &&
                $("#ccm-menu-click-proxy").length == 0
                ) {
            $(el).hide();
        } else if (
                cardsnum.length == 0 &&
                settings.emptystate == "hide" &&
                $("#ccm-menu-click-proxy").length > 0
                ) {
            $(el).css("opacity", 0.5);
            const esm =
                    '<div class="component emptystate">Content List Empty, will disappear in public mode</div>';

            this.insertInDom(
                    el,
                    esm,
                    settings.emptystatepos ? settings.emptystatepos : "append"
                    );
        } else if (cardsnum.length == 0 && settings.emptystate == "message") {
            this.insertInDom(
                    el,
                    '<div class="component emptystate">' +
                    settings.emptystatemessage +
                    "</div>",
                    settings.emptystatepos ? settings.emptystatepos : "append"
                    );
        } else {
            window.ll.update();
        }

        // cerco le contentlist annidate e le attivo
        let near = filters[bid].near;
        $(el)
                .find(".async_content_list:not(.async_content_list_done)")
                .each(function () {
                    let f;
                    try {
                        f = JSON.parse($(this).attr("data-filters"));
                        if (f.near) {
                            f.near = near;
                            $(this).attr("data-filters", JSON.stringify(f));
                        }
                    } catch (e) {
                        console.error(
                                "Error parsing JSON in annidated contentlist",
                                $(this).attr("data-filters")
                                );
                        return;
                    }

                    //return false;
                    // lancio l'attivazione corrente

                    //console.log('00 |||||||||||||||||||| renderContentList annidated', $(this));
                    window.ux.activateLazyContentList(this);

                    // disattivo la contentlist per evitare future attivazioni
                    $(this).addClass("async_content_list_done");
                });
    }

    insertInDom(target, content, strategy) {
        if (strategy == "prepend") {
            $(target).prepend(content);
        } else if (strategy == "append") {
            $(target).append(content);
        } else if (strategy == "before") {
            $(target).before(content);
        } else if (strategy == "after") {
            $(target).after(content);
        } else if (strategy == "replaceWith") {
            $(target).replaceWith(content);
        } else {
            $(target).html(content);
        }

        if (typeof window.__cfBindSectionStepsSlider === "function") {
            const node = target && target.jquery ? target[0] : target;
            window.__cfBindSectionStepsSlider(node || document);
        }

        if (typeof window.__cfBindTestimonialsSlider === "function") {
            const node = target && target.jquery ? target[0] : target;
            window.__cfBindTestimonialsSlider(node || document);
        }
    }

    renderCount(el) {
        let countel;
        if ($(el).attr("data-countable") == true) {
            countel = el;
        } else {
            countel = $(el).closest('[data-countable="true"]');
        }
        if (countel.length > 0) {
            const shown = $(countel).find(".tile").length;
            const total = $(countel).attr("data-total");
            const delta = total - shown;
            const ds = $(countel).find(".drawerset").first();
            const lt = $(countel).find(".tile").last();

            if (delta > 0 && ds.length > 0 && lt.length > 0) {
                const class_ = lt.attr("class");
                ds.before(
                        '<div class="' +
                        class_ +
                        ' counter"><a href="javascript:return void(0)" onclick="window.ux.proxyDrawerTrigger(this)"><div class="tilehead">+' +
                        delta +
                        '</div><div class="tiletitle"><h3 class="title">' +
                        $(countel).attr("data-countlabel") +
                        "</h3></div></a></div>"
                        );
            }
        }
    }

    proxyDrawerTrigger(el) {
        $(el).closest(".contentlist").find(".drawertrigger").trigger("click");
    }

    activateDrawer() {
        $(document).on("click", ".drawertrigger", function () {
            const el = $(this).siblings(".drawer").get(0);

            if (!$(el).is(":empty")) {
                window.ux.openDrawer(el, false);
                return false;
            }

            const wr = $(this).closest(".async_content_list");
            const bid = $(wr).attr("data-bid");
            let filters = {};

            filters[bid] = JSON.parse($(wr).attr("data-filters"));
            filters[bid] = window.ux.shapeFiltersDrawer(filters[bid]);
            filters = window.ux.scanForParentselector(filters, bid);

            const id = $(wr).attr("data-id");
            const segment = $(wr).attr("data-segment");
            const template = $(wr).attr("data-template");
            const settings = JSON.parse($(wr).attr("data-settings"));

            window.ux.getLazyContentList(
                    el,
                    bid,
                    filters,
                    id,
                    segment,
                    template,
                    settings
                    );
        });

        $(document).on("click", ".drawerfader, .drawer .closer", function () {
            window.ux.closeDrawer($(this).closest(".drawerset"));
        });
    }

    shapeFiltersDrawer(filters) {
        filters.listlimit = "100";
        if (JSON.stringify(filters["type"]) == JSON.stringify(["event", "promo"])) {
            delete filters["custom"];
        }
        return filters;
    }

    renderDrawer(el, j, bid, filters) {
        //return false;
        $(el).html(j);

        //hack to avoid recursion
        $(el).find(".drawerset").remove();

        //hack title system
        $(el).find(".contentlist_title > h3").remove();
        $(el).find(".contentlist_title > p").remove();
        $(el).find(".contentlist_title").append('<div class="closer"></div>');

        //hack swiper
        if ($(el).find(".swiper").length > 0) {
            $(el).find(".swiper-controls").remove();
            $(el).find(".swiper").removeClass("swiper").addClass("mask");
            $(el)
                    .find(".swiper-wrapper")
                    .removeClass("swiper-wrapper")
                    .addClass("runner");
        } else {
            $(el)
                    .find(".contentlist_title")
                    .after('<div class="mask"><div class="runner"></div></div>');
            $(el).find(".tile").appendTo($(el).find(".runner"));
        }

        //hack per prodotti
        $(el)
                .find(".tile.product.standard")
                .removeClass("standard")
                .addClass("medium");

        this.openDrawer(el, true);

        let cardsnum = $(el).find("[data-card]");

        if (
                cardsnum.length == 0 &&
                settings.emptystate == "hide" &&
                $("#ccm-menu-click-proxy").length == 0
                ) {
            $(el).hide();
        } else if (
                cardsnum.length == 0 &&
                settings.emptystate == "hide" &&
                $("#ccm-menu-click-proxy").length > 0
                ) {
            $(el).css("opacity", 0.5);
            $(el).append(
                    '<div class="component emptystate">Content List Empty, will disappear in public mode</div>'
                    );
        } else if (cardsnum.length == 0 && settings.emptystate == "message") {
            $(el).append(
                    '<div class="component emptystate">' +
                    settings.emptystatemessage +
                    "</div>"
                    );
        } else {
            window.ll.update();
        }
    }

    openDrawer(el, wait) {
        if (wait) {
            setTimeout(function () {
                $(el).parent(".drawerset").addClass("open");
            }, 200);
        } else {
            $(el).parent(".drawerset").addClass("open");
        }

        $("body").addClass("modalactive");
    }

    closeDrawer(el) {
        $(el).removeClass("open");
        $("body").removeClass("modalactive");
    }

    activateCalendarTrigger() {
        $(".component.calendar")
                .children(".trigger")
                .on("click", function () {
                    $(this).parent().toggleClass("open");
                });
    }

    activateZoomables() {
        $(document).on("click", ".zoomable", function (e) {
            if ($(e.target).attr("role") == "button")
                return;
            $(this).toggleClass("zoomed");

            if ($(this).hasClass("zoomed")) {
                $(this)
                        .find("img[data-original-width]")
                        .each(function () {
                            setTimeout(
                                    $.proxy(function () {
                                        const nh = $(window).height() * 0.8; //$(this).height();
                                        const ow = $(this).attr("data-original-width");
                                        const oh = $(this).attr("data-original-height");

                                        $(this).width((nh * ow) / oh);
                                        $(this).height(nh);
                                    }, this),
                                    500
                                    );
                        });
            } else {
                $(this)
                        .find("img[data-original-width]")
                        .each(function () {
                            $(this).width("");
                            $(this).height("");
                        });
            }
        });
    }

    activateLoadMore() {
        $(document).on("click", ".loadmore:not(.status-disabled)", function () {
            if ($(this).attr("data-role") == "proxy") {
                const targetid = $(this).attr("data-target");
                $('.loadmore[data-targetid="' + targetid + '"]').trigger("click");
                $(this).removeClass("loadmore").addClass("status-loading");
            } else if ($(this).attr("data-mode") == "paginated") {
                window.ux.loadmorePaginated(this);
            } else {
                window.ux.loadmoreContinuous(this);
            }
        });
    }

    loadmoreContinuous(el) {
        // cambio lo status del bottone
        $(el).removeClass("loadmore").addClass("status-loading");

        // recupero l'elemento con i dati
        let cl = $(el).closest("[data-filters]");

        // incremento il from in filters
        let filters = JSON.parse(cl.attr("data-filters"));
        filters.listfrom = parseInt(filters.listfrom) + parseInt(filters.listlimit);
        cl.attr("data-filters", JSON.stringify(filters));

        // incremento il from in pagination
        let pagination = JSON.parse(cl.attr("data-pagination"));
        pagination.from = parseInt(pagination.from) + parseInt(filters.listlimit);
        cl.attr("data-pagination", JSON.stringify(pagination));

        // carico la prossima pagina
//        console.log("00 |||||||||||||||||||| loadmoreContinuous ", $(cl));
        window.ux.activateLazyContentList(cl, el, "replaceWith", "children");
    }

    loadmorePaginated(el) {
        // cambio lo status del bottone
        $(el).removeClass("loadmore").addClass("status-loading");

        // recupero l'elemento con i dati
        let cl = $(el).closest("[data-filters]");

        // modifico il from in filters
        let filters = JSON.parse(cl.attr("data-filters"));
        if ($(el).attr("data-action") == "prev") {
            filters.listfrom =
                    parseInt(filters.listfrom) - parseInt(filters.listlimit);
        } else {
            filters.listfrom =
                    parseInt(filters.listfrom) + parseInt(filters.listlimit);
        }
        cl.attr("data-filters", JSON.stringify(filters));

        // incremento il from in pagination
        let pagination = JSON.parse(
                $(el).closest(".pagination").attr("data-pagination")
                );
        if ($(el).attr("data-action") == "prev") {
            pagination.from = parseInt(pagination.from) - parseInt(filters.listlimit);
        } else {
            pagination.from = parseInt(pagination.from) + parseInt(filters.listlimit);
        }
        $(el)
                .closest(".pagination")
                .attr("data-pagination", JSON.stringify(pagination));

        // mando in skeleton e svuoto la mappa
        $(el)
                .closest(".contentlist")
                .children(".tile")
                .addClass("skeleton")
                .off("mouseenter")
                .off("mouseleave");

        if (typeof window.gmac != typeof undefined) {
            window.gmac.emptyMarkers();

            if ($(window).width() > 991) {
                $("html, body").animate({scrollTop: 0}, 300);
            }
        }

        // carico la prossima pagina
        setTimeout(function () {
            //console.log('00 |||||||||||||||||||| loadmorePaginated ', $(cl));
            window.ux.activateLazyContentList(
                    cl,
                    $(el).closest(".contentlist"),
                    null,
                    "children"
                    );
        }, 100);
    }

    activateHamburger() {
        $(".hamburger").on("click", function () {
            $(this).toggleClass("open");
            $("nav").find(".menu").toggleClass("open");
        });
    }

    fixHPUX() {
        if ($("body").hasClass("homepage")) {
        }
    }

    fixAggregatorUX() {
        if ($("body").hasClass("aggregator")) {
            if ($(window).width() < 576 && typeof window.gmac != typeof undefined) {
                $("html, body").animate({scrollTop: 80}, 300);
                const h = $(window).height() - 57;
                $("section.list").height(h);
                $("section.list").find("aside").height(h);
            }

            $(".fewresults[data-action]").on("click", function () {
                if ($(this).attr("data-action") == "remove-filters") {
                    let url = window.location.href;
                    window.location.href = url.substring(0, url.lastIndexOf("/"));
                }
            });
        }
    }

    fixCartoucheUX() {
        if ($("body").hasClass("store") && $(window).width() < 768) {
            const l = $(".activityswitcher")
                    .find(".component.button")
                    .first()
                    .attr("href");
            $(".cartouche").find(".component.button").attr("href", l);
        } else if (
                ($("body").hasClass("event") ||
                        $("body").hasClass("promo") ||
                        $("body").hasClass("product")) &&
                $(window).width() < 768
                ) {
            const l = $(".component.ctainline").attr("href");
            $(".cartouche").find(".component.button").attr("href", l);
        } else {
            //console.log('no need to fix')
        }
    }

    activateContactTabs() {
        if ($(".contact-tabs").length) {
            $(".single-tab").on("click", function (e) {
                var tabToShow = $(this).attr("data-target");
                if (tabToShow == "club") {
                    $(this)
                            .parent()
                            .parent()
                            .parent()
                            .parent()
                            .parent()
                            .parent()
                            .css("background-color", "#F2F7FE");
                } else {
                    $(this)
                            .parent()
                            .parent()
                            .parent()
                            .parent()
                            .parent()
                            .parent()
                            .css("background-color", "#FFF4F4");
                }
                if (!$(this).hasClass("active")) {
                    $(".single-tab").removeClass("active");
                    $(this).addClass("active");

                    $(".single-content").removeClass("active");
                    $(".single-content." + tabToShow).addClass("active");
                }
            });
        }
    }

    monitorTouchpontSubmit() {
        $("form.touchpoint").on("submit", function () {
            $(this).find('input[type="submit"]').prop("disabled", true);
        });
    }

    fixClubUX() {
        if ($("body").hasClass("store")) {
            setTimeout(function () {
                if (!$(".body > .subscriptions > .async_content_list").is(":visible")) {
                    $('li[data-rel="subscriptions"]').hide();
                }
                if (!$(".body > .activities > .async_content_list").is(":visible")) {
                    $('li[data-rel="activities"]').hide();
                }
                if ($(".component.reviews").length == 0) {
                    $('li[data-rel="reviews"]').hide();
                }
            }, 2000);
        }
    }

    activateDestinationLinks() {
        $(document).on("click", "[data-destination]", function (e) {
            e.preventDefault();
            e.stopPropagation();
            window.location.href = $(this).attr("data-destination");
        });
    }

    activateFormSteps() {
        document.querySelectorAll("form.touchpoint").forEach((form) => {
            if (form.classList.contains("touchpoint-form-variant")) {
                return;
            }
            const formSteps = form.querySelectorAll("fieldset.form-step, fieldset");
            if (formSteps.length < 2) {
                return;
            }

            let currentStep = 0;
            const translations = {
                it: {back: "Indietro", next: "Avanti"},
                es: {back: "Atrás", next: "Siguiente"},
                ca: {back: "Enrere", next: "Següent"},
                fr: {back: "Retour", next: "Suivant"},
                en: {back: "Back", next: "Next"},
            };

            const currentLanguage = (document.documentElement.lang || "it").slice(0, 2);
            const backText = translations[currentLanguage]?.back || translations.en.back;
            const nextText = translations[currentLanguage]?.next || translations.en.next;

            formSteps.forEach((fieldset, index) => {
                const topNavigationWrapper = document.createElement("div");
                topNavigationWrapper.className = "top-navigation";
                topNavigationWrapper.style.display = index === 0 ? "none" : "flex";

                const backButton = document.createElement("button");
                backButton.type = "button";
                backButton.className = "back-button cf-btn cf-btn--outline-dark";
                backButton.setAttribute("data-step", index);
                backButton.setAttribute("aria-label", backText);

                const backIcon = document.createElement("span");
                backIcon.className = "cf-btn__icon";
                backIcon.setAttribute("aria-hidden", "true");
                backIcon.innerHTML = TOUCHPOINT_NEXT_ARROW_SVG;

                const backLabel = document.createElement("span");
                backLabel.className = "cf-btn__label";
                backLabel.textContent = backText;

                backButton.append(backIcon, backLabel);
                topNavigationWrapper.appendChild(backButton);
                fieldset.insertBefore(topNavigationWrapper, fieldset.firstChild);

                backButton.addEventListener("click", function (e) {
                    e.preventDefault();
                    prevStep();
                });

                if (index < formSteps.length - 1) {
                    const navigationWrapper = document.createElement("div");
                    navigationWrapper.className = "form-navigation";

                    const nextButton = document.createElement("button");
                    nextButton.type = "button";
                    nextButton.className = "next-button btn cta";
                    nextButton.setAttribute("data-step", index);

                    const nextLabel = document.createElement("span");
                    nextLabel.className = "cf-btn__label";
                    nextLabel.textContent = nextText;

                    const nextIcon = document.createElement("span");
                    nextIcon.className = "cf-btn__icon";
                    nextIcon.setAttribute("aria-hidden", "true");
                    nextIcon.innerHTML = TOUCHPOINT_NEXT_ARROW_SVG;

                    nextButton.append(nextLabel, nextIcon);
                    navigationWrapper.appendChild(nextButton);
                    fieldset.appendChild(navigationWrapper);

                    nextButton.addEventListener("click", function (e) {
                        e.preventDefault();
                        nextStep();
                    });
                }
            });

            function showStep(stepIndex) {
                formSteps.forEach((step, index) => {
                    step.style.display = index === stepIndex ? "block" : "none";
                });

                const currentFieldset = formSteps[stepIndex];
                if (!currentFieldset) {
                    return;
                }

                const topNavigation = currentFieldset.querySelector(".top-navigation");
                const backButton = currentFieldset.querySelector(".back-button");

                if (topNavigation) {
                    topNavigation.style.display = stepIndex === 0 ? "none" : "flex";
                }

                if (backButton) {
                    backButton.style.display = stepIndex === 0 ? "none" : "inline-flex";
                }
            }

            function nextStep() {
                const requiredFields = formSteps[currentStep].querySelectorAll("[required]");
                let allValid = true;

                requiredFields.forEach((field) => {
                    if (!field.checkValidity()) {
                        allValid = false;
                        field.reportValidity();
                    }
                });

                if (allValid && currentStep < formSteps.length - 1) {
                    currentStep++;
                    showStep(currentStep);
                }
            }

            function prevStep() {
                if (currentStep > 0) {
                    currentStep--;
                    showStep(currentStep);
                }
            }

            showStep(currentStep);
        });
    }
    activateSmartAccordion() {
        $(document).on("click", ".component.accordion .accordion-button[data-bs-target], .component.accordion-viola .accordion-button[data-bs-target]", function (e) {
            e.preventDefault();
            e.stopPropagation();

            const $button = $(this);
            const targetSelector = $button.attr("data-bs-target");
            if (!targetSelector) {
                return;
            }

            const $root = $button.closest(".component.accordion, .component.accordion-viola");
            const $target = $root.find(targetSelector).first();
            if ($target.length === 0) {
                return;
            }

            const isOpen = $target.hasClass("show");

            // Chiudi tutti gli altri pannelli nello stesso accordion.
            $root.find(".accordion-collapse.show").not($target).removeClass("show");
            $root.find(".accordion-button").not($button).addClass("collapsed").attr("aria-expanded", "false");

            // Toggle del pannello cliccato.
            if (isOpen) {
                $target.removeClass("show");
                $button.addClass("collapsed").attr("aria-expanded", "false");
            } else {
                $target.addClass("show");
                $button.removeClass("collapsed").attr("aria-expanded", "true");
            }
        });
    }
    openFirstItemInSmartAccordions() {
        const selectors = ".component.section-servizi, .component.section-faq-dinamic";
        $(selectors).each(function () {
            const $component = $(this);
            const $items = $component.find(".accordion-item");
            if ($items.length === 0) {
                return;
            }

            const $firstButton = $items.first().find(".accordion-button[data-bs-target]").first();
            if ($firstButton.length === 0) {
                return;
            }

            const firstTarget = $firstButton.attr("data-bs-target");
            if (!firstTarget) {
                return;
            }

            const $firstPanel = $component.find(firstTarget).first();
            if ($firstPanel.length === 0) {
                return;
            }

            $component.find(".accordion-collapse.show").removeClass("show");
            $component.find(".accordion-button").addClass("collapsed").attr("aria-expanded", "false");

            $firstPanel.addClass("show");
            $firstButton.removeClass("collapsed").attr("aria-expanded", "true");
        });
    }
    magicAccordion() {
        const accordionContainer = document.querySelector(".accordion.special.magic");
        if (!accordionContainer)
            return;

        const accordionButtons = accordionContainer.querySelectorAll(".accordion-button");
        let imageElement = accordionContainer.querySelector(".col-lg-6 img, .col-lg-6 video");

        if (accordionButtons.length === 0 || !imageElement)
            return;

        const isVideoDefault = imageElement.tagName.toLowerCase() === "video";
        const defaultMediaPath = isVideoDefault ? imageElement.src : null;
        const defaultMediaType = isVideoDefault ? "video" : "image";

        // Funzione per aggiornare il media principale
        function updateMainMedia(path, type) {
            if (!path || window.innerWidth <= 768)
                return;

            const parent = imageElement.parentNode;
            parent.innerHTML = "";

            if (type === "image") {
                const img = document.createElement("img");
                img.src = path;
                img.classList.add("img-fluid");
                parent.appendChild(img);
                imageElement = img;
            } else if (type === "video") {
                const video = document.createElement("video");
                video.src = path;
                video.controls = false;
                video.autoplay = true;
                video.loop = true;
                video.classList.add("w-100");
                parent.appendChild(video);
                imageElement = video;
            }
        }

        // Inserisce immagini negli accordion-body su mobile
        function insertImagesIntoAccordion() {
            if (window.innerWidth > 768)
                return;

            accordionButtons.forEach((button) => {
                const targetId = button.getAttribute("data-bs-target");
                const imagePath = button.getAttribute("data-image");
                const targetElement = accordionContainer.querySelector(targetId);

                if (imagePath && targetElement) {
                    const accordionBody = targetElement.querySelector(".accordion-body");

                    if (accordionBody && !accordionBody.querySelector("img")) {
                        const img = document.createElement("img");
                        img.src = imagePath;
                        img.classList.add("img-fluid", "mb-3");
                        accordionBody.prepend(img);
                    }
                }
            });
        }

        insertImagesIntoAccordion();

        // Rimuove l'attributo di Bootstrap per evitare conflitti
        accordionButtons.forEach((button) => {
            button.removeAttribute("data-bs-toggle"); // Bootstrap non interferirà più
        });

        // Assicura che gli accordion siano inizialmente chiusi
        accordionButtons.forEach((button) => {
            const targetId = button.getAttribute("data-bs-target");
            const targetElement = accordionContainer.querySelector(targetId);

            if (targetElement) {
                targetElement.classList.remove("show");
            }
            button.classList.add("collapsed");
        });

        // Event listener per il click sugli accordion button
        accordionButtons.forEach((button) => {
            button.addEventListener("click", function (event) {
                event.preventDefault(); // Evita il comportamento di Bootstrap
                event.stopPropagation(); // Impedisce propagazione a Bootstrap

                const targetId = this.getAttribute("data-bs-target");
                const targetElement = accordionContainer.querySelector(targetId);

                if (!targetElement)
                    return;

                const isOpen = targetElement.classList.contains("show");

                if (isOpen) {
                    // Se l'accordion è aperto, chiudilo
                    targetElement.classList.remove("show");
                    this.classList.add("collapsed");

                    // Ripristina il media predefinito se nessun accordion è aperto
                    if (!accordionContainer.querySelector(".accordion-collapse.show") && defaultMediaPath) {
                        updateMainMedia(defaultMediaPath, defaultMediaType);
                    }
                } else {
                    // Chiude tutti gli altri accordion e apre solo quello cliccato
                    accordionContainer.querySelectorAll(".accordion-collapse").forEach((collapse) => {
                        collapse.classList.remove("show");
                    });
                    accordionButtons.forEach((btn) => btn.classList.add("collapsed"));

                    targetElement.classList.add("show");
                    this.classList.remove("collapsed");

                    const imagePath = this.getAttribute("data-image");
                    if (imagePath) {
                        updateMainMedia(imagePath, "image");
                    }
                }
            });
        });

        // Ripristina il media predefinito quando tutti gli accordion sono chiusi
        document.addEventListener("click", function () {
            if (window.innerWidth > 768) {
                const openAccordion = accordionContainer.querySelector(".accordion-collapse.show");
                if (!openAccordion && defaultMediaPath) {
                    updateMainMedia(defaultMediaPath, defaultMediaType);
                }
            }
        });
    }
    cleanParagraphEmpty() {
        // Seleziona tutti i paragrafi e verifica il contenuto
        document.querySelectorAll("p").forEach((paragraph) => {
            const content = paragraph.innerHTML.trim(); // Rimuove spazi all'inizio e alla fine
            if (
                    content === "" ||
                    content === "&nbsp;" ||
                    /^\s*<!--.*-->\s*$/.test(content)
                    ) {
                paragraph.remove(); // Rimuove il paragrafo se soddisfa le condizioni
            }
        });
    }
}

module.exports = UXManager;


(function () {
    "use strict";

    var SPACE_DATA = {
        xs: {
            label: "Extra small",
            range: "(1–2 m²)",
            questionHighlight: "macchina",
            chips: [
                {icon: "/application/themes/cmc_theme_uno/dist/assets/images/icon-chair.svg", text: "x1"},
                {icon: "/application/themes/cmc_theme_uno/dist/assets/images/icon-package.svg", text: "x5"},
                {icon: "/application/themes/cmc_theme_uno/dist/assets/images/icon-shelves.svg", text: "x1"},
            ],
        },
        s: {
            label: "Small",
            range: "(fino a 1 m²)",
            questionHighlight: "zaino",
            chips: [
                {icon: "/application/themes/cmc_theme_uno/dist/assets/images/icon-package.svg", text: "x5"},
                {icon: "/application/themes/cmc_theme_uno/dist/assets/images/icon-chair.svg", text: "x0"},
            ],
        },
        m: {
            label: "Medium",
            range: "(1–3 m²)",
            questionHighlight: "auto piccola",
            chips: [
                {icon: "/application/themes/cmc_theme_uno/dist/assets/images/icon-package.svg", text: "x10"},
                {icon: "/application/themes/cmc_theme_uno/dist/assets/images/icon-chair.svg", text: "x1"},
            ],
        },
        l: {
            label: "Large",
            range: "(3–5 m²)",
            questionHighlight: "furgone",
            chips: [
                {icon: "/application/themes/cmc_theme_uno/dist/assets/images/icon-package.svg", text: "x15"},
                {icon: "/application/themes/cmc_theme_uno/dist/assets/images/icon-chair.svg", text: "x1"},
                {icon: "/application/themes/cmc_theme_uno/dist/assets/images/icon-shelves.svg", text: "x1"},
            ],
        },
        xl: {
            label: "Extra large",
            range: "(1–5 m²)",
            questionHighlight: "macchina",
            chips: [
                {icon: "/application/themes/cmc_theme_uno/dist/assets/images/icon-chair.svg", text: "x1"},
                {icon: "/application/themes/cmc_theme_uno/dist/assets/images/icon-package.svg", text: "x20"},
                {icon: "/application/themes/cmc_theme_uno/dist/assets/images/icon-shelves.svg", text: "x1"},
            ],
        },
    };

    function initSpaceToggle() {
        var roots = document.querySelectorAll(".section-spaces");
        if (!roots.length) {
            return;
        }

        roots.forEach(function (root) {
            var buttons = root.querySelectorAll(".cf-size-toggle__btn[data-size]");
            if (!buttons.length) {
                return;
            }

            var panels = root.querySelectorAll(".section-spaces__panel[data-space-size]");
            var staticPanelsMode = panels.length > 0;

            var labelEl = root.querySelector(".js-space-label");
            var rangeEl = root.querySelector(".js-space-range");
            var chipsEl = root.querySelector(".js-space-chips");
            var questionEl = root.querySelector(".js-space-question");

            if (!staticPanelsMode && (!labelEl || !rangeEl || !chipsEl || !questionEl)) {
                return;
            }

            function renderChips(chips) {
                chipsEl.innerHTML = "";
                chips.forEach(function (chip) {
                    var span = document.createElement("span");
                    span.className = "cf-chip";
                    var img = document.createElement("img");
                    img.className = "cf-chip__icon";
                    img.src = chip.icon;
                    img.alt = "";
                    var text = document.createElement("span");
                    text.className = "cf-chip__text";
                    text.textContent = chip.text;
                    span.appendChild(img);
                    span.appendChild(text);
                    chipsEl.appendChild(span);
                });
            }

            function setPressed(activeBtn) {
                buttons.forEach(function (b) {
                    var on = b === activeBtn;
                    b.setAttribute("aria-pressed", on ? "true" : "false");
                });
            }

            function applySize(key, options) {
                var silent = options && options.silent;
                var data = SPACE_DATA[key];
                if (!data) {
                    return;
                }

                if (staticPanelsMode) {
                    panels.forEach(function (panel) {
                        var on = panel.getAttribute("data-space-size") === key;
                        panel.classList.toggle("is-active", on);
                    });

                    if (!silent) {
                        var livePanel = root.querySelector("#space-selection-live");
                        if (livePanel) {
                            livePanel.textContent =
                                "Selezionato: " + data.label + " " + data.range.replace(/[()]/g, "").trim() + ".";
                        }
                    }
                    return;
                }

                labelEl.textContent = data.label;
                rangeEl.textContent = data.range;
                renderChips(data.chips);
                questionEl.innerHTML =
                    "Riesci a portare tutto in una <span class=\"accent\">" +
                    data.questionHighlight +
                    "</span>?";
                if (!silent) {
                    var liveEl = root.querySelector("#space-selection-live");
                    if (liveEl) {
                        liveEl.textContent =
                            "Selezionato: " + data.label + " " + data.range.replace(/[()]/g, "").trim() + ".";
                    }
                }
            }

            buttons.forEach(function (btn) {
                btn.addEventListener("click", function () {
                    var key = btn.getAttribute("data-size");
                    setPressed(btn);
                    applySize(key);
                });
            });

            var initial =
                root.querySelector('.cf-size-toggle__btn[aria-pressed="true"]') ||
                root.querySelector(".cf-size-toggle__btn");

            if (initial && initial.getAttribute("data-size")) {
                setPressed(initial);
                applySize(initial.getAttribute("data-size"), {silent: true});
            }
        });
    }

    function syncAccordionAria() {
        if (typeof bootstrap === "undefined") {
            return;
        }
        document.querySelectorAll(".cf-accordion").forEach(function (root) {
            root.querySelectorAll(".accordion-collapse").forEach(function (panel) {
                panel.addEventListener("shown.bs.collapse", function () {
                    var id = panel.getAttribute("id");
                    var btn = root.querySelector('[aria-controls="' + id + '"]');
                    if (btn) {
                        btn.setAttribute("aria-expanded", "true");
                    }
                });
                panel.addEventListener("hidden.bs.collapse", function () {
                    var id = panel.getAttribute("id");
                    var btn = root.querySelector('[aria-controls="' + id + '"]');
                    if (btn) {
                        btn.setAttribute("aria-expanded", "false");
                    }
                });
            });
        });
    }

    function initTopicChips() {
        document.querySelectorAll(".cf-topic-chip").forEach(function (chip) {
            chip.addEventListener("click", function () {
                var pressed = chip.getAttribute("aria-pressed") === "true";
                chip.setAttribute("aria-pressed", pressed ? "false" : "true");
            });
        });
    }
    
    function checkSubmitTp() {
        const container = document.querySelector('.form-quote.form-quote__sticky');

        if (!container) {
            return;
        }

        function toggleTitle() {
            const thankyou = container.querySelector('.thankyoumessage');
            const title = container.querySelector('#form-quote-title');

            if (thankyou && title) {
                title.style.display = 'none';
            }
        }

        // Controllo immediato (nel caso il messaggio sia già presente)
        toggleTitle();

        const observer = new MutationObserver(function () {
            toggleTitle();
        });

        observer.observe(container, {
            childList: true,
            subtree: true
        });
    }

    document.addEventListener("DOMContentLoaded", function () {
        initSpaceToggle();
        syncAccordionAria();
        initTopicChips();
        checkSubmitTp();
    });
})();
